import {
  HttpErrorResponse,
  type HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SKIP_ERROR_REPORT } from '../http-error/http-error-context.tokens';
import { HttpErrorReporterService } from '../http-error/http-error-reporter.service';
import type { NormalizedApiError } from '../http-error/http-error.models';

const normalizeErrorPayload = (payload: unknown) => {
  if (typeof payload === 'string') {
    const truncatedMessage = payload.slice(0, 300);
    return { message: truncatedMessage };
  }

  if (payload && typeof payload === 'object') {
    return payload;
  }

  return {
    message: 'Unexpected error',
  };
};

export const normalizeHttpError = (error: unknown): NormalizedApiError => {
  if (error instanceof HttpErrorResponse) {
    return new HttpErrorResponse({
      error: normalizeErrorPayload(error.error),
      headers: error.headers,
      status: error.status,
      statusText: error.statusText,
      url: error.url ?? undefined,
    });
  }

  return new HttpErrorResponse({
    error: normalizeErrorPayload(error),
    status: 0,
    statusText: 'Unknown error occurred, please try again',
  });
};

export const errorReportingInterceptor: HttpInterceptorFn = (req, next) => {
  const reporter = inject(HttpErrorReporterService);

  return next(req).pipe(
    catchError((error) => {
      const normalizedError = normalizeHttpError(error);

      if (!req.context.get(SKIP_ERROR_REPORT)) {
        reporter.report(normalizedError, req);
      }

      return throwError(() => normalizedError);
    }),
  );
};
